import { HTMLAttributes } from "react";
import { cx } from "@app/shared/utils/cx";
import styles from "./Card.module.css";

export type CardProps = HTMLAttributes<HTMLDivElement> & {
  padded?: boolean;
  interactive?: boolean;
  /**
   * Opts into the "grouped list" treatment for pages that stack several
   * Cards as one continuous run of sections (Order Details, Stop Details,
   * Event History): edge-to-edge and divided by a 1px line between
   * consecutive grouped Cards on mobile/tablet, like a native settings
   * list; reverts to the normal rounded/shadowed card at the `lg`
   * breakpoint (768px). Off by default — e.g. the sandbox's scenario-picker
   * tiles use plain Cards in a grid and should never flatten.
   */
  grouped?: boolean;
};

/** Generic surface container — the base every content block in the sandbox
 * sits on (order summary, stop cards, event rows, custom field lists...). */
export const Card = ({ padded = true, interactive = false, grouped = false, className, ...rest }: CardProps) => (
  <div
    className={cx(
      styles.card,
      padded && styles.padded,
      interactive && styles.interactive,
      grouped && styles.grouped,
      className
    )}
    {...rest}
  />
);
